import React from 'react';
import { authButtonStyle, authButtonSmallStyle } from '../../constants/authStyles';
import { ItemImage } from './inventoryBagGridUtils';

const InventoryItemPopup = ({
  item,
  onClose,
  closeLabel,
  renderItemNameWithPlating,
  renderItemPlatingBlock,
  categoryLabel,
  characterName,
  levelLabel,
  enhancementLabel,
  statRows,
  renderStatRow,
  efsunCountLabel,
  efsunRows,
  compatibilityLabel,
  fishOpenKind,
  canCookFish,
  canSmeltOre,
  canSmeltOreWithCount,
  smeltInputCount,
  canUseCookedFish,
  cookedFishEffect,
  canUseCropFood,
  cropFoodEffect,
  canUseLootBoost,
  lootBoostEffect,
  isBossStomachOpenable,
  fishOpenLoading,
  fishCookLoading,
  fishUseLoading,
  cropUseLoading,
  lootBoostLoading,
  oreSmeltLoading,
  bossStomachOpenLoading,
  onOpenFish,
  onCookFish,
  onSmeltOre,
  onUseCookedFish,
  onUseCropFood,
  onUseLootBoost,
  onOpenBossStomach,
  isRecipeBook = false,
  recipeBookLoading = false,
  onReadRecipeBook,
  readRecipeBookLabel,
  npcSellLabel,
  sellButtonLabel,
  sellQuantity,
  onDecreaseSellQuantity,
  onIncreaseSellQuantity,
  onSellToMarket,
  sellLoading,
  sellTotalLabel,
  openFishLabel,
  cookFishLabel,
  smeltOreLabel,
  useFishLabel,
  useCropLabel,
  openBossStomachLabel,
  decreaseQtyLabel,
  increaseQtyLabel,
  hideActions = false,
  previewNote = null,
  enhancePutInSlotLabel,
  onPutInEnhanceSlot,
  enhanceRemoveFromSlotLabel,
  onRemoveFromEnhanceSlot,
}) => {
  if (!item) return null;

  return (
    <div className="inventory-item-popup-backdrop" onClick={onClose}>
      <div className="inventory-item-popup inventory-item-popup--modal" onClick={(event) => event.stopPropagation()}>
        <button
          type="button"
          className="inventory-item-popup-close"
          onClick={onClose}
          aria-label={closeLabel}
        >
          X
        </button>
        <div className="inventory-popup-body">
          <div className="inventory-popup-details">
            {renderItemNameWithPlating(item.baseItem.name, item, 'h4')}
            {renderItemPlatingBlock(item)}
            <p>{categoryLabel}: {item.categoryLabel}</p>
            <p>{characterName.label}: {characterName.value}</p>
            <p>{levelLabel}: {item.baseItem.level}</p>
            <p>{enhancementLabel}: +{item.baseItem.enhancement || 0}</p>
            {statRows.map((row, index) => renderStatRow(row, `inventory-popup-${row.label}-${index}`))}
            {efsunCountLabel ? (
              <p className="inventory-efsun-header">{efsunCountLabel}</p>
            ) : null}
            {efsunRows.map((row, index) => (
              <p key={`item-popup-efsun-${row.label}-${index}`} className="inventory-efsun-row">
                {row.label}: <span className={row.colorClass}>{row.value}</span>
              </p>
            ))}
            <p>{compatibilityLabel}</p>
            {previewNote ? (
              <p className="inventory-popup-preview-note">{previewNote}</p>
            ) : null}
            {onPutInEnhanceSlot ? (
              <div className="inventory-popup-open">
                <button
                  type="button"
                  className="auth-button auth-button--compact inventory-popup-open-submit"
                  style={authButtonStyle}
                  onClick={onPutInEnhanceSlot}
                >
                  {enhancePutInSlotLabel}
                </button>
              </div>
            ) : null}
            {onRemoveFromEnhanceSlot ? (
              <div className="inventory-popup-open">
                <button
                  type="button"
                  className="auth-button auth-button--compact inventory-popup-open-submit"
                  style={authButtonStyle}
                  onClick={onRemoveFromEnhanceSlot}
                >
                  {enhanceRemoveFromSlotLabel}
                </button>
              </div>
            ) : null}
            {!hideActions && item.inventoryType === 'others' && fishOpenKind && (
              <div className="inventory-popup-open">
                <button
                  type="button"
                  className="auth-button auth-button--compact inventory-popup-open-submit"
                  style={authButtonStyle}
                  disabled={fishOpenLoading || fishCookLoading || fishUseLoading || oreSmeltLoading}
                  onClick={() => onOpenFish(item.id)}
                >
                  {fishOpenLoading ? '…' : openFishLabel}
                </button>
                {canCookFish && (
                  <button
                    type="button"
                    className="auth-button auth-button--compact inventory-popup-open-submit"
                    style={authButtonStyle}
                    disabled={fishCookLoading || fishOpenLoading || fishUseLoading || oreSmeltLoading}
                    onClick={() => onCookFish(item.id)}
                  >
                    {fishCookLoading ? '…' : cookFishLabel}
                  </button>
                )}
              </div>
            )}
            {!hideActions && item.inventoryType === 'others' && canSmeltOre && (
              <div className="inventory-popup-open">
                <button
                  type="button"
                  className="auth-button auth-button--compact inventory-popup-open-submit"
                  style={authButtonStyle}
                  disabled={oreSmeltLoading || fishOpenLoading || fishCookLoading || fishUseLoading || !canSmeltOreWithCount}
                  onClick={() => onSmeltOre(item.baseItem.id)}
                >
                  {oreSmeltLoading ? '…' : smeltOreLabel}
                </button>
              </div>
            )}
            {!hideActions && item.inventoryType === 'others' && canUseCookedFish && (
              <div className="inventory-popup-open">
                {cookedFishEffect ? (
                  <p className="inventory-fish-effect">{cookedFishEffect}</p>
                ) : null}
                <button
                  type="button"
                  className="auth-button auth-button--compact inventory-popup-open-submit"
                  style={authButtonStyle}
                  disabled={fishUseLoading || cropUseLoading || fishOpenLoading || fishCookLoading}
                  onClick={() => onUseCookedFish(item.id)}
                >
                  {fishUseLoading ? '…' : useFishLabel}
                </button>
              </div>
            )}
            {!hideActions && item.inventoryType === 'others' && canUseCropFood && (
              <div className="inventory-popup-open">
                {cropFoodEffect ? (
                  <p className="inventory-fish-effect">{cropFoodEffect}</p>
                ) : null}
                <button
                  type="button"
                  className="auth-button auth-button--compact inventory-popup-open-submit"
                  style={authButtonStyle}
                  disabled={cropUseLoading || fishUseLoading || fishOpenLoading || fishCookLoading}
                  onClick={() => onUseCropFood(item.id)}
                >
                  {cropUseLoading ? '…' : useCropLabel}
                </button>
              </div>
            )}
            {!hideActions && item.inventoryType === 'others' && canUseLootBoost && (
              <div className="inventory-popup-open">
                {lootBoostEffect ? (
                  <p className="inventory-fish-effect">{lootBoostEffect}</p>
                ) : null}
                <button
                  type="button"
                  className="auth-button auth-button--compact inventory-popup-open-submit"
                  style={authButtonStyle}
                  disabled={lootBoostLoading || cropUseLoading || fishUseLoading || fishOpenLoading || fishCookLoading}
                  onClick={() => onUseLootBoost(item.id)}
                >
                  {lootBoostLoading ? '…' : useCropLabel}
                </button>
              </div>
            )}
            {!hideActions && item.inventoryType === 'others' && isRecipeBook && onReadRecipeBook && (
              <div className="inventory-popup-open">
                <button
                  type="button"
                  className="auth-button auth-button--compact inventory-popup-open-submit"
                  style={authButtonStyle}
                  disabled={recipeBookLoading}
                  onClick={() => onReadRecipeBook(item.baseItem.id)}
                >
                  {recipeBookLoading ? '…' : readRecipeBookLabel}
                </button>
              </div>
            )}
            {!hideActions && item.inventoryType === 'others' && isBossStomachOpenable && (
              <div className="inventory-popup-open">
                <button
                  type="button"
                  className="auth-button auth-button--compact inventory-popup-open-submit"
                  style={authButtonStyle}
                  disabled={bossStomachOpenLoading}
                  onClick={() => onOpenBossStomach(item.baseItem.id)}
                >
                  {bossStomachOpenLoading ? '…' : openBossStomachLabel}
                </button>
              </div>
            )}
            {!hideActions ? (
            <div className="inventory-popup-sell">
              <div className="inventory-popup-sell-label">{npcSellLabel}</div>
              <div className="inventory-popup-sell-row">
                <button
                  type="button"
                  className="auth-button auth-button--compact inventory-popup-sell-step"
                  style={authButtonSmallStyle}
                  disabled={sellLoading || sellQuantity <= 1}
                  onClick={onDecreaseSellQuantity}
                  aria-label={decreaseQtyLabel}
                >
                  −
                </button>
                <span className="inventory-popup-sell-qty">{sellQuantity}</span>
                <button
                  type="button"
                  className="auth-button auth-button--compact inventory-popup-sell-step"
                  style={authButtonSmallStyle}
                  disabled={sellLoading || sellQuantity >= (item.count || 1)}
                  onClick={onIncreaseSellQuantity}
                  aria-label={increaseQtyLabel}
                >
                  +
                </button>
                <button
                  type="button"
                  className="auth-button auth-button--compact inventory-popup-sell-submit"
                  style={authButtonStyle}
                  disabled={sellLoading}
                  onClick={onSellToMarket}
                >
                  {sellLoading ? '…' : sellButtonLabel}
                </button>
              </div>
              <div className="inventory-popup-sell-total">{sellTotalLabel}</div>
            </div>
            ) : null}
          </div>
          {item.baseItem.imageUrl ? (
            <div className="inventory-popup-image">
              <ItemImage
                imageUrl={item.baseItem.imageUrl}
                alt={item.baseItem.name}
                singleFrameSprite={
                  item.inventoryType === 'boots' ||
                  item.slotType === 'boot'
                }
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default InventoryItemPopup;
